export const ReasonCodes = {
    ResourceNotFound: 67,
};
